"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultCowriterSelectionCriteria = exports.defaultPagination = void 0;
const mobx_1 = require("mobx");
const calc_num_pages_1 = require("@App/helpers/pagination/calc-num-pages");
const search_1 = require("@App/api/routes/search");
const get_num_titles_1 = require("@App/helpers/pagination/get-num-titles");
const search_criteria_store_1 = __importDefault(require("@App/stores/search/search-criteria-store"));
const search_option_type_1 = require("@App/enum/search-option-type");
const required_criteria_1 = require("@App/enum/required-criteria");
const get_search_query_1 = require("@App/helpers/get-search-query");
const cowriter_1 = require("@App/api/routes/songwriter/cowriter");
const format_name_1 = require("@App/helpers/format-name");
exports.defaultPagination = {
    lastPage: 0,
    cappedLastPage: undefined,
    currentPage: 1,
    refined: false,
};
exports.defaultCowriterSelectionCriteria = [
    {
        id: get_search_query_1.SEARCH_COWRITER_OPTIONS[0].id,
        selectedOption: get_search_query_1.SEARCH_COWRITER_OPTIONS[0],
        searchTerm: '',
        isFixed: true,
    },
];
class CowriterSearchPartyStore {
    createWriterSearchCriteriaStore() {
        const writerSearchMaxCriteria = 4;
        return new search_criteria_store_1.default(exports.defaultCowriterSelectionCriteria, get_search_query_1.SEARCH_COWRITER_OPTIONS, search_option_type_1.SearchOptionType.primary, required_criteria_1.RequiredCriteria.primaryFilter, writerSearchMaxCriteria);
    }
    constructor(rootStore) {
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_publicSearchByPartySearchQuery", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                writerName: '',
                publisherName: '',
                recordedBy: '',
                recordingName: '',
            }
        });
        Object.defineProperty(this, "_searchResultPartyDetails", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_publicSearchByPartyCriteriaPaginationInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_publicSearchByPartyWorksPaginationInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: exports.defaultPagination
        });
        Object.defineProperty(this, "_currentPartyResultsPerPageLimit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_currentWorkResultsPerPageLimit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_currentSearchCriteriaStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "selectedWriterName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "selectedWriterIpId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_totalNumberOfResults", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_selectedWorks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_showWorks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "displayType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'public'
        });
        Object.defineProperty(this, "canAddCriteria", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "searchCowriterWorks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (search, pagination) => __awaiter(this, void 0, void 0, function* () {
                this.rootStore.preloaderStore.openTransparentPreloader(true);
                const apiResponse = yield (0, search_1.searchCowriterWorks)(this.rootStore.songwriterStore.currentSongwriterId, pagination, search);
                (0, mobx_1.runInAction)(() => {
                    this._publicSearchByPartyWorksPaginationInfo = (0, calc_num_pages_1.calcNumPages)(apiResponse.data.totalElements, pagination.limit, pagination.page);
                });
                this.rootStore.preloaderStore.openTransparentPreloader(false);
                return {
                    count: apiResponse.data.totalElements,
                    works: apiResponse.data.content,
                };
            })
        });
        (0, mobx_1.makeObservable)(this, {
            _searchResultPartyDetails: mobx_1.observable,
            _totalNumberOfResults: mobx_1.observable,
            _selectedWorks: mobx_1.observable,
            _showWorks: mobx_1.observable,
            _currentSearchCriteriaStore: mobx_1.observable,
            _publicSearchByPartyCriteriaPaginationInfo: mobx_1.observable,
            _currentPartyResultsPerPageLimit: mobx_1.observable,
            _publicSearchByPartyWorksPaginationInfo: mobx_1.observable,
            numTitles: mobx_1.computed,
            partyWorksNumTitles: mobx_1.computed,
            worksResultMessage: mobx_1.computed,
            setCurrentPaginationPage: mobx_1.action,
            setQuery: mobx_1.action,
            setCurrentResultsPerPageLimit: mobx_1.action,
            setShowWorks: mobx_1.action,
            resetStore: mobx_1.action,
            resetWorks: mobx_1.action,
            resetWritersAndWorks: mobx_1.action,
        });
        this.rootStore = rootStore;
        this.resetStore();
    }
    get searchResultPartyDetails() {
        return this._searchResultPartyDetails;
    }
    get publicSearchByPartyCriteriaPaginationInfo() {
        return this._publicSearchByPartyCriteriaPaginationInfo;
    }
    get publicSearchByPartyWorksPaginationInfo() {
        return this._publicSearchByPartyWorksPaginationInfo;
    }
    get currentPartyResultsPerPageLimit() {
        return this._currentPartyResultsPerPageLimit;
    }
    get currentWorkResultsPerPageLimit() {
        return this._currentWorkResultsPerPageLimit;
    }
    get selectedWorks() {
        return this._selectedWorks;
    }
    get showWorks() {
        return this._showWorks;
    }
    get totalNumberOfResults() {
        return this._totalNumberOfResults;
    }
    get numTitles() {
        var _a;
        return (0, get_num_titles_1.getNumTitles)(this._totalNumberOfResults, (_a = this._publicSearchByPartyCriteriaPaginationInfo.currentPage) !== null && _a !== void 0 ? _a : 1, this._currentPartyResultsPerPageLimit);
    }
    get partyWorksNumTitles() {
        var _a, _b, _c, _d;
        return (0, get_num_titles_1.getNumTitles)((_b = (_a = this._selectedWorks) === null || _a === void 0 ? void 0 : _a.count) !== null && _b !== void 0 ? _b : 0, (_d = (_c = this._publicSearchByPartyWorksPaginationInfo) === null || _c === void 0 ? void 0 : _c.currentPage) !== null && _d !== void 0 ? _d : 1, this._currentWorkResultsPerPageLimit);
    }
    get worksResultMessage() {
        if (this.selectedWriterName) {
            return `Works for ${this.selectedWriterName}`;
        }
        return 'Works';
    }
    get searchCriteriaStore() {
        return this._currentSearchCriteriaStore;
    }
    setSelectedWorks(works) {
        this._selectedWorks = works;
    }
    setCurrentPaginationPage(page) {
        this._publicSearchByPartyCriteriaPaginationInfo.currentPage = page !== null && page !== void 0 ? page : 1;
    }
    searchForWorksByPartyDetails(writer) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            this.setSelectedWriterIpId((_a = writer.ipId) !== null && _a !== void 0 ? _a : '');
            this.setSelectedWriterName(writer.name);
            const searchWorksQuery = {
                writerIpIds: (_b = writer.ipId) !== null && _b !== void 0 ? _b : '',
            };
            this.searchCowriterWorks(searchWorksQuery, (_c = this._publicSearchByPartyWorksPaginationInfo) !== null && _c !== void 0 ? _c : exports.defaultPagination).then((result) => {
                (0, mobx_1.runInAction)(() => {
                    this.setSelectedWorks(result);
                    this.setShowWorks(true);
                });
            });
        });
    }
    setSelectedWriterName(name) {
        this.selectedWriterName = name;
    }
    setSelectedWriterIpId(ipId) {
        this.selectedWriterIpId = ipId;
    }
    setQuery(search) {
        this._publicSearchByPartySearchQuery = search;
    }
    setCurrentResultsPerPageLimit(newLimit) {
        return __awaiter(this, void 0, void 0, function* () {
            this._currentPartyResultsPerPageLimit = newLimit;
            yield this.searchForParties();
        });
    }
    setShowWorks(showWritersWorks) {
        this._showWorks = showWritersWorks;
    }
    searchForParties() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getCowriters(this._publicSearchByPartySearchQuery);
        });
    }
    onChangeWorksPage(paginationBody) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.selectedWriterIpId) {
                this.resetWorks();
                const search = {
                    writerIpIds: this.selectedWriterIpId,
                };
                try {
                    const response = yield this.searchCowriterWorks(search, paginationBody);
                    (0, mobx_1.runInAction)(() => {
                        var _a;
                        this._selectedWorks = response;
                        if (paginationBody.limit && paginationBody.page && response) {
                            this._publicSearchByPartyWorksPaginationInfo = (0, calc_num_pages_1.calcNumPages)(response.count, paginationBody.limit, (_a = paginationBody.page) !== null && _a !== void 0 ? _a : 1, paginationBody.refined);
                        }
                    });
                }
                catch (e) {
                    this.rootStore.popupStore.setAlertFromError(e);
                }
            }
        });
    }
    onChangeWorkResultsLimit(newLimit) {
        return __awaiter(this, void 0, void 0, function* () {
            this._currentWorkResultsPerPageLimit = newLimit;
            const pagination = { page: 1, limit: newLimit };
            yield this.onChangeWorksPage(pagination);
        });
    }
    resetStore() {
        this._currentPartyResultsPerPageLimit = 10;
        this.resetWritersAndWorks();
        this.resetSearchCriteriaStore();
        this._publicSearchByPartySearchQuery = {
            writerName: '',
            publisherName: '',
            recordedBy: '',
            recordingName: '',
        };
    }
    resetSearchCriteriaStore() {
        this._currentSearchCriteriaStore = this.createWriterSearchCriteriaStore();
    }
    resetWorks() {
        this._selectedWorks = undefined;
        this._publicSearchByPartyWorksPaginationInfo = exports.defaultPagination;
    }
    resetWritersAndWorks() {
        this.resetSearchCriteriaStore();
        this._showWorks = false;
        this._searchResultPartyDetails = [];
        this._publicSearchByPartyCriteriaPaginationInfo = exports.defaultPagination;
        this._totalNumberOfResults = 0;
        this.selectedWriterName = '';
        this.selectedWriterIpId = undefined;
        this._currentWorkResultsPerPageLimit = 10;
        this.resetWorks();
    }
    getCowritersApiCall(songwriterId, pagination, search) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, cowriter_1.searchCowriters)(songwriterId, pagination, search).then((response) => response.data);
        });
    }
    getCowriters(search) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            try {
                const response = yield this.getCowritersApiCall(this.rootStore.songwriterStore.currentSongwriterId, {
                    page: (_a = this._publicSearchByPartyCriteriaPaginationInfo.currentPage) !== null && _a !== void 0 ? _a : 1,
                    limit: this._currentPartyResultsPerPageLimit,
                }, search);
                (0, mobx_1.runInAction)(() => {
                    var _a;
                    this._totalNumberOfResults = response.totalElements;
                    this._publicSearchByPartyCriteriaPaginationInfo = (0, calc_num_pages_1.calcNumPages)(this._totalNumberOfResults, this._currentPartyResultsPerPageLimit, (_a = this._publicSearchByPartyCriteriaPaginationInfo.currentPage) !== null && _a !== void 0 ? _a : 1);
                    this._searchResultPartyDetails = response.content.map((writer) => {
                        var _a;
                        return ({
                            ipId: writer.ipId,
                            ipiNumber: writer.ipiNumber,
                            worksCount: writer.worksCount,
                            name: (_a = (0, format_name_1.formatName)(writer.firstName, writer.lastName)) !== null && _a !== void 0 ? _a : '',
                        });
                    });
                });
            }
            catch (e) {
                this.rootStore.popupStore.setAlertFromError(e);
            }
        });
    }
}
exports.default = CowriterSearchPartyStore;
